import React, { FC, useContext } from 'react';
import { ErrorMessage } from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import ChangePasswordContext from '../../../../utils/ChangePasswordContext';

export interface ErrorMessageBoxProps { }

const ErrorMessageBox: FC<ErrorMessageBoxProps> = () => {
  const { t } = useTranslation('ChangePasswordPage');
  const { rules } = useContext(ChangePasswordContext);

  const errProps = {
    name: 'ErrMessage',
    error: t('PasswordError'),
  };

  return (
    <>
      {rules?.ErrorMessageText?.length > 0 ? <><strong><ErrorMessage {...errProps} /></strong><br /></> : null}
    </>
  );
};
export default ErrorMessageBox;
